import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { Button, Modal, Table } from "antd";
import { formatCNPJ, formatCPF } from "../../../../../utils/format-cpfcnpj";

const columns = [
  {
    title: "NOME",
    dataIndex: "nome",
    key: "nome",
  },
  {
    title: "CPF/CNPJ",
    dataIndex: "cpf_cnpj",
    key: "cpf_cnpj",
  },
  {
    title: "RESPONSABILIDADE",
    dataIndex: "responsabilidade",
    key: "responsabilidade",
  },
  {
    title: "TIPO PESSOA",
    dataIndex: "tipo_pessoa",
    key: "tipo_pessoa",
  },
];

function formatPFPJ(value) {
  return ["pf", "PF"].includes(value) ? "Pessoa Física" : "Pessoa Jurídica";
}

export const ParticipantesModal = ({
  participantes = [],
  visible,
  onCancel,
}) => {
  const tableData = useMemo(
    () =>
      (participantes || []).map((participante) => ({
        key: participante.cpf_cnpj,
        nome: participante.nome,
        cpf_cnpj:
          participante.cpf_cnpj && participante.cpf_cnpj.length > 11
            ? formatCNPJ(participante.cpf_cnpj)
            : formatCPF(participante.cpf_cnpj),
        responsabilidade: participante.responsabilidade,
        tipo_pessoa: `${participante.pf_pj} (${formatPFPJ(
          participante.pf_pj
        )})`,
      })),
    [participantes]
  );

  return (
    <Modal
      title="Participantes"
      width={800}
      closable
      onCancel={onCancel}
      visible={visible}
      footer={[
        <Button key="close" type="primary" onClick={onCancel}>
          Fechar
        </Button>,
      ]}
    >
      <div
        style={{
          margin: "-24px -24px -25px -24px",
        }}
      >
        <Table
          pagination={false}
          locale={{
            emptyText: "Vazio",
          }}
          columns={columns}
          dataSource={tableData}
        />
      </div>
    </Modal>
  );
};

ParticipantesModal.propTypes = {
  participantes: PropTypes.arrayOf(
    PropTypes.shape({
      nome: PropTypes.string,
      pf_pj: PropTypes.string,
      cpf_cnpj: PropTypes.string,
      responsabilidade: PropTypes.string,
    })
  ),
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/Contrato/ParticipantesModal/index.jsx